import {
  OrderStatus,
  SUCCESS_EQUITY_ORDER_RESPONSE,
} from "@/generated/TradingGateway"

import type {
  EquityOrder,
  PlaceEquityOrderRequest,
  SuccessEquityOrderResponse,
} from "../OrderService"

// This function generates a mock UUID in place of crypto.randomUUID() for
// environments where crypto.randomUUID() is not available.
const mockOrderId = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("")
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join("-")
}

export const createMockOrderResponse = (
  input: PlaceEquityOrderRequest,
): SuccessEquityOrderResponse => {
  const todaysDateInNano = BigInt(Date.now()) * BigInt(1_000_000)

  return {
    type: SUCCESS_EQUITY_ORDER_RESPONSE,
    payload: {
      id: mockOrderId(),
      symbol: input.symbol,
      side: input.side,
      notional: input.notional,
      qty: input.qty,
      orderType: input.orderType,
      timeInForce: input.timeInForce,
      status: OrderStatus.New,
      createdAt: todaysDateInNano,
      updateAt: todaysDateInNano,
      filledQty: 0,
    } satisfies EquityOrder,
  }
}
